import { HStack, Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SingleSelectedOfferPrice from './SingleSelectedOfferPrice';

interface Props {
  price: string;
  interval: string;
}

const SelectedOfferSummaryTotal: React.FC<React.PropsWithChildren<Props>> = ({
  price,
  interval,
  ...otherProps
}) => {
  const { t } = useTranslation();

  return (
    <HStack width="100%" {...otherProps}>
      <Text fontWeight="bold" as="h6" fontSize="lg" color="black" flexGrow={1}>
        {t('Total')}
      </Text>
      <SingleSelectedOfferPrice
        price={price}
        interval={interval}
        fontSize="lg"
        color="primary.500"
      />
    </HStack>
  );
};

export default SelectedOfferSummaryTotal;
